import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { ChartCard, ChartEmpty } from './ChartCard';

interface Point { time: string; price: number; }
interface Props { kospi: Point[]; kosdaq: Point[]; }

const fmtIndex = (v: number) => v.toLocaleString('ko-KR', { maximumFractionDigits: 2 });

function MiniLine({ data, color }: { data: Point[]; color: string }) {
  if (data.length === 0) return <ChartEmpty />;
  const labelInterval = Math.max(1, Math.ceil(data.length / 6));
  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data} margin={{ top: 6, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis dataKey="time" tick={{ fontSize: 10 }} interval={labelInterval} />
        <YAxis
          domain={['auto', 'auto']}
          allowDataOverflow={false}
          tick={{ fontSize: 11 }}
          tickFormatter={fmtIndex}
          width={80}
        />
        <Tooltip
          formatter={(value: number) => [fmtIndex(value), '지수']}
          labelFormatter={(label: string) => `시간 ${label}`}
        />
        <Line type="monotone" dataKey="price" stroke={color} strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}

/** 모닝 브리핑 — 국장 마감 KOSPI / KOSDAQ 당일 분봉 (어제 세션). */
export function KrMorningChart({ kospi, kosdaq }: Props) {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <ChartCard title="KOSPI" subtitle="당일 5분봉">
        <MiniLine data={kospi} color="#ef4444" />
      </ChartCard>
      <ChartCard title="KOSDAQ" subtitle="당일 5분봉">
        <MiniLine data={kosdaq} color="#0284c7" />
      </ChartCard>
    </div>
  );
}
